package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
data class RetryConfig(val initialDelay: Long, val exponentialBase: Int, val retryAttempts: Int)

val DEFAULT_RETRY_CONFIG = RetryConfig(1000L, 2, 0)